import { gql } from '@/shared/graphql/generated/cache';

export const getCacheLiquidityQuery = gql(/* GraphQL */ `
  query GetCacheLiquidity($lpIdSs58: String) {
    balances: allDepositBalances(condition: { lpIdSs58: $lpIdSs58 }) {
      groupedAggregates(groupBy: ASSET) {
        sum {
          amount
        }
        keys
      }
    }
    boost: allBoostPools {
      aggregates {
        sum {
          availableAmountValueUsd
          unavailableAmountValueUsd
        }
      }
    }
    strategies: allTradingStrategies {
      aggregates {
        sum {
          quoteAssetBalanceUsd
          baseAssetBalanceUsd
        }
      }
    }
  }
`);
